<div
  (click)="onSelect()"
  (keydown.enter)="onSelect()"
  role="button"
  tabindex="0"
  class="group relative flex flex-col rounded-3xl border border-gray-6 bg-gray-1 p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer overflow-hidden border-l-[6px] border-l-primary"
>
  <!-- Decorative background -->
  <div
    class="absolute -right-6 -top-6 w-24 h-24 bg-indigo-a3 rounded-full blur-2xl group-hover:bg-indigo-a5 transition-all"
  ></div>

  <div class="flex-1 relative z-10">
    <div class="flex items-center justify-between">
      <h3
        class="text-2xl font-extrabold text-gray-12 group-hover:text-primary transition-colors leading-tight mb-2"
      >
        {{ draft().definition.offerType | etxeEnumDisplay: 'offerType' }} -
        {{ draft().definition.propertyType | etxeEnumDisplay: 'propertyType' }}
      </h3>
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        (click)="$event.stopPropagation()"
        class="text-gray-9 hover:text-primary transition-colors"
      >
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #menu="matMenu" class="shadow-xl">
        <button mat-menu-item (click)="onDelete()">
          <mat-icon>delete_outline</mat-icon>
          Supprimer le brouillon
        </button>
      </mat-menu>
    </div>

    <p class="text-gray-11 font-medium flex items-center mb-6">
      <mat-icon class="text-gray-10 text-lg w-5 h-5 mr-2">location_on</mat-icon>
      <span class="text-gray-11 font-medium">
        {{ draft().location.address.street || 'Adresse non renseignée' }}
        {{ draft().location.address.city }},
        {{ draft().location.address.country | countryIso2 }}
        @if (draft().location.address.region) {
          <span class="text-gray-10 ml-1">({{ draft().location.address.region }})</span>
        }
      </span>
    </p>
    <div class="text-[10px] text-gray-9 font-medium uppercase tracking-tight">
      Créé le: {{ draft().createdAt | date: 'medium' }}
    </div>
  </div>

  <div class="mt-auto pt-6 border-t border-gray-2 flex items-center justify-between relative z-10">
    <div class="flex flex-col">
      <span class="text-[10px] text-gray-10 uppercase font-bold tracking-widest">Dernière étape</span>
      <span class="text-sm font-black text-gray-11">
        {{ draft().farthestStepReached | etxeEnumDisplay: 'creationStep' }}
      </span>
    </div>

    <div
      class="w-12 h-12 rounded-2xl bg-indigo-a3 text-indigo-9 flex items-center justify-center group-hover:bg-indigo-9 group-hover:text-white group-hover:scale-110 transition-all duration-300"
    >
      <mat-icon class="scale-110 group-hover:text-white">arrow_forward</mat-icon>
    </div>
  </div>

  @if (appStore.debugMode()) {
    <div class="mt-4 flex flex-col gap-1">
      <aura-clipboard
        class="text-[10px] text-gray-9 font-mono"
        [textToCopy]="draft()._id"
        (click)="$event.stopPropagation()"
      >
        {{ draft()._id }}
      </aura-clipboard>
    </div>
  }
</div>
